<template>
    <div class="payment-method columns">
        <div v-if="!editMode" class="column is-12 is-8-desktop">
            <div v-if="paymentType === 'card'">
                <div class="non-edit-wrapper columns is-multiline" v-if="hasCreditCard">
                    <div class="column is-12">
                        <h3>{{ $t('settings.payment.card.savedData') }}</h3>
                        <div class="flex-wrapper">
                            <div class="data">
                                <div class="no-wrap">
                                    <span class="icon"><i aria-hidden="true" class="fa fa-credit-card"></i></span>
                                    <span class="tag">**** {{ paymentData.number }}</span>
                                </div>
                                <div class="no-wrap"><span class="tag">{{ paymentData.holder }}</span></div>
                                <div class="no-wrap"><span class="tag">{{ $t('settings.payment.card.validUntil') }} {{ paymentData.month }}/{{ paymentData.year }}</span></div>
                            </div>
                            <div class="action">
                                <button class="button is-primary is-pulled-right" @click.prevent="editMode = !editMode">{{ $t('settings.payment.buttons.change') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="non-edit-wrapper columns is-multiline" v-else>
                    <div class="column is-12">
                        <article class="message is-danger">
                            <div class="message-header">
                                <p>{{ $t('settings.payment.card.noSavedData') }}</p>
                            </div>
                            <div class="message-body">
                                <button class="button is-primary" @click.prevent="editMode = !editMode">{{ $t('settings.payment.card.addCreditCard') }}</button>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="non-edit-wrapper columns is-multiline" v-if="hasBankAccount">
                    <div class="column is-12">
                        <h3>{{ $t('settings.payment.bank.savedData') }}</h3>
                        <div class="flex-wrapper">
                            <div class="data">
                                <div class="no-wrap">
                                    <span class="icon"><i aria-hidden="true" class="fa fa-university"></i></span>
                                    <span class="tag">{{ ibanHumanReadable }}</span>
                                </div>
                                <div class="no-wrap"><span class="tag">{{ paymentData.owner }}</span></div>
                            </div>
                            <div class="action">
                                <button class="button is-primary is-pulled-right" @click.prevent="editMode = !editMode">{{ $t('settings.payment.buttons.change') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="non-edit-wrapper columns is-multiline" v-else>
                    <div class="column is-12">
                        <article class="message is-danger">
                            <div class="message-header">
                                <p>{{ $t('settings.payment.bank.noSavedData') }}</p>
                            </div>
                            <div class="message-body">
                                <button class="button is-primary" @click.prevent="editMode = !editMode">{{ $t('settings.payment.bank.addBankAccount') }}</button>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="column is-12 is-8-desktop">

            <div class="edit-wrapper" v-if="paymentType === 'card'">
                <div class="columns">
                    <div class="column is-3">
                        <label for="company_name" class="label edit-box__includes-inline-input">
                            {{ $t('settings.billing.companyName') }}:
                        </label>
                    </div>
                    <div class="column is-9">
                        <input class="input readonly" type="text" id="company_name" name="company_name" :value="companyName" readonly />
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-3">
                        <label for="card_holder" class="label edit-box__includes-inline-input">
                            {{ $t('settings.payment.card.holder') }}
                        </label>
                    </div>
                    <div class="column is-9">
                        <input class="input" type="text" id="card_holder" name="card_holder" v-model="holder" :class="{'is-danger': hasError('holder')}" />
                        <span class="help is-danger" v-if="hasError('holder')">
                            {{ getError('holder') }}
                        </span>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-3">
                        <label for="card_number" class="label edit-box__includes-inline-input">
                            {{ $t('settings.payment.card.number') }}
                        </label>
                    </div>
                    <div class="column is-9">
                        <input class="input" type="text" id="card_number" name="card_number" v-model="number" :class="{'is-danger': hasError('number')}" />
                        <span class="help is-danger" v-if="hasError('number')">
                            {{ getError('number') }}
                        </span>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-3">
                        <label for="card_expiry_month" class="label edit-box__includes-inline-input">
                            {{ $t('settings.payment.card.validUntil') }}
                        </label>
                    </div>
                    <div class="column is-9">
                        <p class="control control-card_expiry">
                            <input type="number" id="card_expiry_month" name="card_expiry_month" class="input" step="1" min="1" max="12" :placeholder="$t('settings.payment.card.monthPlaceholder')" v-model="month" :class="{'is-danger': hasError('month')}" />
                            <span class="expiry-divider">/</span>
                            <input type="number" id="card_expiry_year" name="card_expiry_year" class="input" step="1" :min="new Date().getFullYear()" :max="new Date().getFullYear() + 20" :placeholder="$t('settings.payment.card.yearPlaceholder')" v-model="year" :class="{'is-danger': hasError('year')}" />
                        <span class="help is-danger" v-if="hasError('year') || hasError('month')">
                            <ul>
                                <li>
                                    {{ getError('month') }}
                                </li>
                                <li>
                                    {{ getError('year') }}
                                </li>
                            </ul>
                        </span>
                        </p>
                    </div>
                </div>

                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="colums">
                             <div class="column is-12">
                                <article class="message is-danger" v-if="settingsError">
                                    <div class="message-header">
                                        <p>{{ $t('generic.formErrorHeadline') }}</p>
                                    </div>
                                    <div class="message-body">
                                        <div class="generic-error" v-html="settingsError"></div>
                                    </div>
                                </article>
                            </div>
                        </div>
                        <article class="message is-danger" v-if="genericError">
                            <div class="message-header">
                                <p>{{ $t('generic.formErrorHeadline') }}</p>
                            </div>
                            <div class="message-body">
                                <div>{{this.$t('settings.payment.adyenError')}}</div>
                                <div class="generic-error" v-html="genericError"></div>
                                <p v-html="this.$t('settings.payment.adyenErrorCta', {SERVICE_EMAIL_LINK: SERVICE_EMAIL_LINK})"></p>
                            </div>
                        </article>
                    </div>
                    <div class="column is-12">
                        <button class="button save-button is-primary is-pulled-right" @click.prevent="save()" :class="{'is-loading': loading}">{{ $t('generic.save') }} *</button>
                        <button class="button is-pulled-right" @click.prevent="editMode = !editMode" :class="{'is-loading': loading}">{{ $t('generic.cancel') }}</button>
                    </div>
                    <div class="column is-12">
                        <p class="is-pulled-right note">* {{ $t('settings.payment.card.note') }}</p>
                    </div>
                </div>
            </div>

             <div class="edit-wrapper" v-else>
                <div class="columns">
                    <div class="column is-3">
                        <label for="company_name" class="label edit-box__includes-inline-input">
                            {{ $t('settings.billing.companyName') }}:
                        </label>
                    </div>
                    <div class="column is-9">
                        <input class="input readonly" type="text" id="company_name" name="company_name" :value="companyName" readonly />
                    </div>
                </div>

                 <div class="columns">
                    <div class="column is-3">
                        <label for="bankaccount_owner" class="label edit-box__includes-inline-input">
                            {{ $t('settings.payment.bank.owner') }}
                        </label>
                    </div>
                    <div class="column is-9">
                        <input class="input" type="text" id="bankaccount_owner" name="bankaccount_owner" v-model="owner" :class="{'is-danger': hasError('owner')}" />
                        <span class="help is-danger" v-if="hasError('owner')">
                            {{ getError('owner') }}
                        </span>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-3">
                        <label for="bankaccount_iban" class="label edit-box__includes-inline-input">
                            {{ $t('settings.payment.bank.iban') }}
                        </label>
                    </div>
                    <div class="column is-9">
                        <input class="input" type="text" id="bankaccount_iban" name="bankaccount_iban" v-model="iban" :class="{'is-danger': hasError('iban')}" />
                        <span class="help is-danger" v-if="hasError('iban')">
                            {{ getError('iban') }}
                        </span>
                    </div>
                </div>

                <div class="columns is-multiline">
                <div class="column is-12">
                    <div class="colums">
                             <div class="column is-12">
                                <article class="message is-danger" v-if="settingsError">
                                    <div class="message-header">
                                        <p>{{ $t('generic.formErrorHeadline') }}</p>
                                    </div>
                                    <div class="message-body">
                                        <div class="generic-error" v-html="settingsError"></div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    <article class="message is-danger" v-if="genericError">
                        <div class="message-header">
                            <p>{{ $t('generic.formErrorHeadline') }}</p>
                        </div>
                        <div class="message-body">
                            <div>{{this.$t('settings.payment.adyenError')}}</div>
                            <div class="generic-error" v-html="genericError"></div>
                            <p v-html="this.$t('settings.payment.adyenErrorCta', {SERVICE_EMAIL_LINK: SERVICE_EMAIL_LINK})"></p>
                        </div>
                    </article>
                </div>
                <div class="column is-12">
                    <button class="button save-button is-primary is-pulled-right" @click.prevent="save()" :class="{'is-loading': loading}">{{ $t('generic.save') }} *</button>
                    <button class="button is-pulled-right" @click.prevent="editMode = !editMode" :class="{'is-loading': loading}">{{ $t('generic.cancel') }}</button>
                </div>
                <div class="column is-12">
                    <p class="is-pulled-right note">* {{ $t('settings.payment.bank.note') }}</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Api} from '../../../api';
import {AppModel} from '../../../models';
import {EventBus} from '../../../utils';

export default {
    name: 'payment-method',
    props: {
        paymentType: {
            type: String,
            'default': () => 'bank',
        },
        paymentData: {
            type: Object,
            'default': () => {},
        },
        companyName: {
            type: String,
            'default': () => '',
        },
    },
    data() {
        return {
            SERVICE_EMAIL_LINK: AppModel.serviceEmailLink,
            editMode: false,
            loading: false,
            iban: null,
            owner: null,
            number: null,
            holder: null,
            month: null,
            year: null,
            formErrors: {},
            genericError: '',
            settingsError: false,
        };
    },
    computed: {
        ibanHumanReadable() {
            return (this.paymentData.iban || '').replace(':', ' **** ');
        },
        hasCreditCard() {
            const d = this.paymentData;
            return d.number && d.holder && d.month && d.year;
        },
        hasBankAccount() {
            const d = this.paymentData;
            return d.iban && d.owner;
        },
        paymentDataOut() {
            if(this.paymentType === 'bank') {
                return {
                    'company_name': this.companyName,
                    'payment_type': 'bank',
                    iban: this.iban,
                    owner: this.owner,
                };
            } else {
                return {
                    'company_name': this.companyName,
                    'payment_type': 'card',
                    number: this.number,
                    holder: this.holder,
                    month: this.month,
                    year: this.year,
                };
            }
        }
    },
    methods: {
        save() {
            this.loading = true;
            this.genericError = '';
            this.formErrors = {};
            Api.payment.save(this.paymentDataOut).then(response => {
                this.loading = false;
                if(Math.floor(response.status / 100) !== 2) {
                    this.onError(response.body);
                } else {
                    if(!response.body.success) {
                        const error = response.body.error;
                        if(typeof error === 'string' || error instanceof String) {
                            this.genericError = `<p>${error}</p>`;
                        } else if(typeof error === 'object' || error instanceof Object) {
                            this.genericError = '<ul>';
                            for(let key in error) {
                                if(error.hasOwnProperty(key)) {
                                    this.genericError += `<li>${key}: ${error[key]}</li>`;
                                }
                            }
                        }
                    } else {
                        EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('generic.saveSuccessHeadline')}</h3>`, direction: 'Up', body: this.$t('generic.saveSuccess') });
                        this.editMode = false;
                        delete response.body.success;
                        this.$emit('saved', response.body);
                    }
                }
            });
        },
        onError(errors) {
            this.settingsError = false;
            for(let key in errors) {
                if(errors.hasOwnProperty(key)) {
                    if(key === 'settings') {
                        this.settingsError = errors[key];
                    }
                    this.$set(this.formErrors, key, errors[key][0]);
                }
            }
        },
        hasError(field) {
            return !!this.getError(field);
        },
        getError(field) {
            return this.formErrors[field];
        }
    },
};
</script>

<style lang="scss">
    @import 'payment-method';
</style>



// WEBPACK FOOTER //
// src/views/components/payment-method/payment-method.vue